<div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>

<div class="table-container">
    <div id="header-container" class="d-flex justify-content-end gap-3 mt-1 mb-3">
        <div class="">
            <div class="search-container">
                <span class="fa fa-search form-control-feedback"></span>
                <input type="text" class="form-control search_input" style="font-size: 13px;" placeholder="Search"
                    [(ngModel)]="searchValue">
            </div>
        </div>
        <div class="">
            <div class="action-buttons-container d-flex gap-2">
                <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                    (click)="openReport('Excel')" (keydown.enter)="openReport('Excel')">
                    <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
                    <span class="reload_text text-white">Excel Report</span>
                </div>
                <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                    (click)="openReport('Pdf')" (keydown.enter)="openReport('Pdf')">
                    <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
                    <span class="reload_text text-white">PDF Report</span>
                </div>
            </div>
        </div>
    </div>
    <table class="dynamic-table-container">
        <th style="min-width: 60px; text-align: center;"
            [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
            <div style="display: flex;">
                <div>
                    <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
                </div>
            </div>
        </th>
        <th id="grid-header-container" onFocus
            *ngFor="let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray; let ix = index;" [ngStyle]="{'min-width': oneQmsUsersDataForTable1Data.width,'max-width': oneQmsUsersDataForTable1Data.width,'overflow': 'hidden',
      'text-overflow': 'ellipsis',
      'white-space': 'nowrap'}" class="sticky-dynamic-col1" (mouseover)="cssfunction(0)">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                <span>{{oneQmsUsersDataForTable1Data.fieldColumnarray}}</span>
                <div class="d-flex gap-2 align-items-center">
                    <div class="sort"
                        (click)="sortColumn(columnLists.columnsListarray[ix],oneQmsUsersDataForTable1Data)"
                        (keydown.enter)="sortColumn(columnLists.columnsListarray[ix],oneQmsUsersDataForTable1Data)">
                        <div><i *ngIf="sortedDisplayColumn==oneQmsUsersDataForTable1Data.fieldColumnarray && sortDirection=='asc'"
                                class='fas fa-angle-up' style='font-size:11px'></i></div>
                        <div><i *ngIf="sortedDisplayColumn==oneQmsUsersDataForTable1Data.fieldColumnarray && sortDirection=='desc'"
                                class='fas fa-angle-down' style='font-size:11px'></i></div>
                        <img *ngIf="sortedDisplayColumn!=oneQmsUsersDataForTable1Data.fieldColumnarray"
                            src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                    </div>
                </div>
            </div>
        </th>
        <th id="menu" class="sticky-col first-col"></th>
        <!-- search input row is added -->
        <tr>
            <td [class]="
                makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : ''
              "></td>
            <td *ngFor="let taskDocumentsDataForGridData of columnLists.fieldColumnarray; let ix = index;"
                [ngStyle]="{'min-width': taskDocumentsDataForGridData.width !=null ? taskDocumentsDataForGridData.width :200,'max-width': taskDocumentsDataForGridData.width !=null ? taskDocumentsDataForGridData.width :200}"
                class="sticky-dynamic-col1">
                <div class="row-search-container">
                    <input type="text" class="form-control" placeholder="Search"
                        (input)="applyFilter3(columnLists.columnsListarray[ix],$event)">
                </div>
            </td>
        </tr>
        <!-- data row -->
        <tr *ngFor="let list of pagedItems  | searchFilter : searchValue; let idx = index;"
            [class.highlightRow]="list.childCheckBoxs == true">
            <td style="min-width: 60px; text-align: center;"
                [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
                <div style="display: flex;">
                    <div [ngClass]="list.childCheckBoxs ?'static_icon':'hover-menu-icons'">
                        <i class="fa-solid fa-ellipsis-vertical"></i>
                    </div>
                    <div>
                        <input type="checkbox" style="zoom: 1.2;" [checked]="list.childCheckBoxs"
                            (change)="dataGridChildCheckBoxChecked($event, list, idx)">
                    </div>
                </div>
            </td>
            <td id="grid-row-container" *ngFor="let key of columnLists.columnsListarray1; let i = index;"
                (focus)="focusEmpty()" class="sticky-dynamic-row1" [ngStyle]="{'min-width': key.width[i],'max-width': key.width[i],'overflow': 'hidden',
        'text-overflow': 'ellipsis',
        'white-space': 'nowrap'}" (mouseover)="cssfunction(i)" matTooltipClass="tooltip-withoutbreak"
                [matTooltip]="list[key.columnsListarray] === 'htmlClobView' ? '' : list[key.columnsListarray]">
                <span *ngIf="key.dataType=='CHECKBOX'">
                    <div class="gridCheckBoxes">
                        <img *ngIf="list[key.columnsListarray]" src="../../assets/img/accessSymbol.svg" width="20"
                            height="20" alt="Yes">
                        <img *ngIf="list[key.columnsListarray]==false" src="../../assets/img/noAcessSymbol.svg"
                            width="20" height="20" alt="No">
                    </div>
                </span>
                <span *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE'">{{ list[key.columnsListarray]
                    }}</span>
                <span *ngIf="key.dataType=='DATE'">
                    {{ list[key.columnsListarray]}}
                </span>
            </td>
        </tr>
    </table>
    <div class="d-flex justify-content-center">
        <div class="width-cheat small paginationCell">
            <div class="d-flex align-items-center gap-3">
                <div class="pagination_text mt-3">
                    {{ showingRowsText }}
                    1-{{ perPage }} of {{ collectionSize | number }}
                </div>
                <div>
                    <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)"
                        [disabled]="false" [collectionSize]="pager.totalItems" [(page)]="pager.currentPage"
                        [maxSize]="maxSize" [rotate]="true" [pageSize]="perPage" [ellipses]="false"
                        [boundaryLinks]="true" size="sm">
                    </ngb-pagination>
                </div>
                <div ngbDropdown class="mt-3">
                    <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic1"
                        ngbDropdownToggle>
                        {{ perPage }}
                        <i class="ms-1 fa-solid fa-chevron-down"></i>
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                        <button ngbDropdownItem (click)="paginationCall(10)">10</button>
                        <button ngbDropdownItem (click)="paginationCall(20)">20</button>
                        <button ngbDropdownItem (click)="paginationCall(50)">50</button>
                    </div>
                    per page
                </div>
            </div>
        </div>
    </div>
</div>

<app-excel-pdf #excelPdfPopup [excelPdf]="excelPdf"></app-excel-pdf>